import React from 'react'
import { Box, Typography } from '@mui/material'

// One "Label: value" line of a section.
export default function Fact({ label, children }) {
  return (
    <Typography variant="body2" component="div">
      <Box component="span" sx={{ fontWeight: 'bold' }}>
        {label}:
      </Box>{' '}
      <span>{children}</span>
    </Typography>
  )
}
